<template>
    <div class="custom-radio">
        <input
                type="radio"
                :name="name"
                :id="id"
                :checked="checked"
                :value="value"
                :required="required"
                @change="updateInput"
        />
        <label :for="id">{{ label }}</label>
    </div>
</template>
<script>
    export default {
        name: 'radio',
        props: {
            name: {
                type: String,
                required: false
            },
            id: {
                type: String,
                required: false
            },
            value: {
                type: String,
                required: false
            },
            required: {
                type: Boolean,
                required: false,
                default: false
            },
            checked: {
                type: Boolean,
                required: false,
                default: false
            },
            label: {
                type: String,
                required: true
            }
        },
        methods: {
            updateInput: function (event) {
                this.$emit('changed', event.target.value);
            }
        }
    };
</script>
